import React, { useState, FunctionComponent } from "react"
import LevelsOfCriticalityPage from "../../components/concerns/levels-of-criticality/index"
import ActionSidebar from "../../components/layout/action-sidebar"
import Navigation from "../navigation"

interface Props {
  children?: React.ReactChildren
  criticalFunctionId: number
  isRightSidebarEnabled: boolean | undefined
  baseFormId: string
  currentRailsPath: string
}

interface FormStateProps {
  needsSave: boolean
  loading: boolean
}

const MainContentWrapper: FunctionComponent<Props> = ({
  criticalFunctionId,
  isRightSidebarEnabled,
  baseFormId = "react-form",
  currentRailsPath
}) => {
  // Keep track of internal state of form status to share between components
  const [formState, setFormState] = useState<FormStateProps>({
    needsSave: false,
    loading: false
  })

  const handleFormPageChange: React.SetStateAction<object> = (
    formState: FormStateProps
  ) => {
    setFormState(formState)
  }

  return (
    <React.Fragment>
      <div className="page-container">
        <div id="mainContent" className="page-content">
          <Navigation
            showFacultyLink={document.body.dataset.facultyLinkEnabled ? true : false}
            currentRailsPath={currentRailsPath}
          />
          <LevelsOfCriticalityPage
            formId={baseFormId}
            criticalFunctionId={criticalFunctionId}
            isReactRightSidebarEnabled={isRightSidebarEnabled}
            onFormChange={handleFormPageChange}
          />
        </div>
        {isRightSidebarEnabled && (
          <ActionSidebar formId={baseFormId} formState={formState} />
        )}
      </div>
    </React.Fragment>
  )
}

export default MainContentWrapper
